"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("@headlessui/react");
const Button_1 = require("./Button");
const Item_1 = require("./Item");
const Items_1 = require("./Items");
const useDropdownProps_1 = require("./useDropdownProps");
const Column_1 = require("../Column");
const Row_1 = require("../Row");
const DropdownElement = styled_1.default.div({
    position: 'relative',
});
const Dropdown = (props) => {
    const filteredItems = props.items.filter((item) => !item.hidden);
    if (filteredItems.length === 0) {
        return null;
    }
    const iconPlaceholder = props.items.some((item) => item.icon)
        ? null
        : undefined;
    return ((0, jsx_runtime_1.jsx)(useDropdownProps_1.DropdownPropsContextProvider, { ...props, children: (0, jsx_runtime_1.jsx)(DropdownElement, { children: (0, jsx_runtime_1.jsxs)(react_1.Menu, { children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, { children: [props.children, (0, jsx_runtime_1.jsx)(Button_1.DropdownButton, { className: props.buttonClassName, compact: props.compact, design: props.design, fullWidth: props.fullWidth, icon: props.buttonIcon, size: props.size, text: props.buttonText })] }), (0, jsx_runtime_1.jsx)(Column_1.Column, { position: "relative", children: (0, jsx_runtime_1.jsx)(Items_1.DropdownItems, { alignItems: props.alignItems, children: filteredItems.map((item) => ((0, jsx_runtime_1.jsx)(Item_1.DropdownItem, { disabled: item.disabled, icon: item.icon ?? iconPlaceholder, onClick: item.onClick, small: props.size !== 'md', children: item.label }, item.key))) }) })] }) }) }));
};
exports.Dropdown = Dropdown;
